

<form edlFocusTrap [formGroup]="form" novalidate errorTailor>
    <div class="modal-body">
        <div class="content" *ngIf="busy" >
                <div class="loader"></div>
        </div>

        <div class="col-sm-12">
            <h4 class="card-title">
                <timetracking-status-indicator *ngIf="details!=null"
                    [statusId]="details.StatusID"
                    [a48ContextCode]="details.ContextCode"
                    [timeTrackingType]="TimeTrackingType.ACT48"
                ></timetracking-status-indicator>
                    {{details.UserDisplayName}} - Submission Status</h4>
            <small *ngIf="!DateHelpers.isMinDate(details.SubmissionTimeStamp)">Last Updated: {{details.SubmissionTimeStamp | date: 'medium' }}</small>
            <p class="card-text" [innerHTML]="details.Status"></p>
        </div>
        <hr>
        <div class="row" *ngIf="!busy">
            <div class="col-sm-12" *ngIf="canDisplaySubmitHoursToggle()">
                <label class="form-label">
                    <div>Submit to PERMS </div>
                    <toggle-indicator
                        formControlName="ShouldSubmitToPerms"
                        OnLabel="Yes" OffLabel="No"  ></toggle-indicator>
                </label>
            </div>
            <div class="col-sm-12">
                <div class="form-group">
                    <label for="a48PPID" class="form-label">PPID
                        <span *ngIf="isPpidRequired" class="required">*</span>
                        <span *ngIf="!isPpidRequired">(if applicable)</span>
                        </label>
                    <input type="text" id="a48PPID" maxlength="7" class="form-control" formControlName="PPID"
                        [class.is-invalid]="form.get('PPID')?.invalid && form.get('PPID')?.touched"
                        [attr.aria-invalid]="form.get('PPID')?.invalid && form.get('PPID')?.touched ? 'true' : null"
                        [attr.aria-describedby]="form.get('PPID')?.invalid && form.get('PPID')?.touched ? 'a48PPID-error' : null" />
                    <div id="a48PPID-error"
                         class="invalid-feedback"
                         [class.d-block]="form.get('PPID')?.invalid && form.get('PPID')?.touched"
                         role="alert"
                         controlErrorAnchor>
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="form-group">
                    <label for="a48Hours" class="form-label">
                        <span>{{a48HelpersService.getHoursOrCreditsFullLabel(form.get('ActivityType').value)}}: </span>
                        <span class="required">*</span>
                    </label>
                    <input type="number" id="a48Hours" min="0" step="0.5" (change)="ensureGreaterThanZero()" class="form-control" formControlName="Hours" controlErrorsIgnore />
                    <div class="small required">{{a48HelpersService.getHoursError(form.get('ActivityType').value, form.get('Hours').errors)}}</div>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="form-group">
                    <label for="a48Provider" class="form-label">Provider<span class="required">*</span></label>
                    <input type="text" id="a48Provider" class="form-control" formControlName="Provider" />
                </div>
            </div>

            <div class="col-sm-12" *ngIf="aunSettings.length > 1 && AdminUI">
                <div class="form-group">
                    <label class="form-label" for="aunSelect">AUN: <span class="required"
                        *ngIf="form.get('AUN').validator">*</span></label>
                    <select id="aunSelect" class="form-select" formControlName="AUN">
                        <option [value]="null">Select AUN</option>
                        <option *ngFor="let aun of aunSettings"
                            [value]="aun.AUN">
                            {{aun.AUNName}} ({{aun.AUN}})
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="form-group">
                    <label for="a48EventName" class="form-label">{{a48HelpersService.getEventNameLabel(form.get('ActivityType').value)}}<span class="required">*</span></label>
                    <input type="text" id="a48EventName" class="form-control" formControlName="EventName" />
                </div>
            </div>

            <div class="col-sm-6">
                <div class="form-group">
                    <label for="a48EventStart" class="form-label">Event Start<span class="required">*</span></label>
                    <edl-date-picker id="a48EventStart" formControlName="EventStart"
                        [class.is-invalid]="form.get('EventStart')?.invalid && form.get('EventStart')?.touched"
                        [attr.aria-invalid]="form.get('EventStart')?.invalid && form.get('EventStart')?.touched ? 'true' : null"
                        [attr.aria-describedby]="form.get('EventStart')?.invalid && form.get('EventStart')?.touched ? 'a48EventStart-error' : null"></edl-date-picker>
                    <div id="a48EventStart-error"
                         class="invalid-feedback d-block"
                         *ngIf="form.get('EventStart')?.invalid && form.get('EventStart')?.touched"
                         role="alert">
                        <span *ngIf="form.get('EventStart')?.errors?.['required']">
                            This field is required.
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label for="a48EventEnd" class="form-label">Event End<span class="required">*</span></label>
                    <edl-date-picker id="a48EventEnd" formControlName="EventEnd"
                        [class.is-invalid]="form.get('EventEnd')?.invalid && form.get('EventEnd')?.touched"
                        [attr.aria-invalid]="form.get('EventEnd')?.invalid && form.get('EventEnd')?.touched ? 'true' : null"
                        [attr.aria-describedby]="form.get('EventEnd')?.invalid && form.get('EventEnd')?.touched ? 'a48EventEnd-error' : null"></edl-date-picker>
                    <div id="a48EventEnd-error"
                         class="invalid-feedback d-block"
                         *ngIf="form.get('EventEnd')?.invalid && form.get('EventEnd')?.touched"
                         role="alert">
                        <span *ngIf="form.get('EventEnd')?.errors?.['required']">
                            This field is required.
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="form-group">
                    <label class="form-label" for="activityTypeSelect">Activity Type: <span class="required"
                        *ngIf="form.get('ActivityType').validator">*</span></label>
                        <select id="activityTypeSelect" [attr.disabled]="activityTypes.length === 1 ? true : null" class="form-select" formControlName="ActivityType">
                            <option [value]="null">Select Activity Type</option>
                            <option *ngFor="let optionValue of activityTypes"
                                [value]="optionValue.id">
                                {{ optionValue.name }}
                            </option>
                        </select>
                </div>
            </div>
            <div class="col-sm-12" *ngIf="form.get('ActivityType').value == A48ActivityType.CREDITS">
                <div class="form-group">
                    <label class="form-label" for="collegeCreditTypeSelect">College Credit Type: <span class="required"
                            *ngIf="isCollegeCreditTypeRequired(form)">*</span></label>
                    <select id="collegeCreditTypeSelect" class="form-select" formControlName="CollegeCreditType">
                        <option value="">Select a college credit type</option>
                        <option
                            *ngFor="let optionValue of collegeCreditTypes"
                            [value]="optionValue.id">
                            {{ optionValue.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-sm-12" *ngIf="isParaApplicable">
                <div class="form-group">
                    <label class="form-label" for="cecPerformanceSelect">CEC Performance Standard: <span class="required">*</span> </label>
                    <select id="cecPerformanceSelect" class="form-select" formControlName="CECPerformanceStandard" >
                        <option value="">Select</option>
                        <option *ngFor="let optionValue of cecPerformanceTypes"
                            [value]="optionValue.id">
                            {{ optionValue.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" [disabled]="!shouldEnableSaveButton()" (click)="onSubmit(form, false)">Save</button>
        <button type="button" *ngIf="!IsAdminView" class="btn btn-primary" (click)="onSubmit(form, true)" [disabled]="isReadOnly || form.invalid">Confirm</button>

        <button type="button" class="btn btn-primary" *ngIf="showResubmitButton()" (click)="onResubmit(form)" [disabled]="form.invalid">Resubmit</button>
        <button type="button" *ngIf="ShowCloseBtn" class="btn btn-info" (click)="cancel()">Close</button>
    </div>
</form>
